export { default as VideoPlayer } from './VideoPlayer';
